module.exports = "https://img1.zhuanstatic.com/platform/zz-universal-pages/static/img/wudingdan.253443a0.png";